export default __webpack_public_path__ + "static/media/BMSVNCKH-08B ĐXDTHĐT.b68df22a.docx";